define('home/models/ChannelGroupProfile',[
    'underscore',
    'backbone',

    'core/api',
    'core/UniqueModel',

    'home/models/Channel',
    'home/models/Feed',
    'home/collections/FeedItemCollection',
    'home/collections/ChannelCollection',
], function (
    _,
    Backbone,

    api,
    UniqueModel,

    Channel,
    Feed,
    FeedItemCollection,
    ChannelCollection
) {
    'use strict';

    /**
     * A ChannelGroup and its feeds.
     *
     * Since a ChannelGroup is currently backed by a Channel, ChannelGroups
     * should be 1-to-1 with a Channel model.
     */
    var ChannelGroupProfile = Backbone.Model.extend({
        initialize: function (_attributes, options) {
            options = options || {};

            // The special instance of the ChannelGroupProfile that contains
            // content accross all channel groups, as indicated by a specific
            // id, does not have a single channel
            if (this.id && this.id !== this.constructor.ALL_CHANNEL_GROUPS_PROFILE_ID) {
                this.initializeRelated(
                    'channel',
                    options,
                    Channel
                );
            }

            this.rankedChannels = _.chain(this.constructor.RANKINGS)
                .map(function (ranking) {
                    var feed = new Feed({
                        fetchOptions: {
                            name: ranking.name,
                            channel: this.channel && this.channel.id,
                            attach: 'counters',
                        },
                    }, {
                        collectionClass: ChannelCollection,
                        collectionUrl: api.getURL('channels/listRanked'),
                    });

                    return [ranking.id, feed];
                }, this)
                .object()
                .value();

            this.topActivities = new Feed(options.topActivitiesOptions, {
                collectionClass: FeedItemCollection,
                collectionUrl: api.getURL('timelines/ranked'),
                collectionOptions: {
                    type: 'default',
                    target: this.channel && ('channel:' + this.channel.id),
                },
            });
        },

        toJSON: function () {
            // Don't bother calling prototype's toJSON since this is a ViewModel
            // that doesn't store any attributes itself, only groups other Models
            // and Collections.
            return {
                channel: this.channel.toJSON(),
            };
        },

        ensureFetched: function () {
            this.ensureFetchedChannel();
            this.ensureFetchedTopActivities();
            _.each(this.constructor.RANKINGS, function (ranking) {
                this.ensureFetchedRankedChannels(ranking.id);
            });
        },

        ensureFetchedChannel: function () {
            this.channel.ensureFetched();
        },

        ensureFetchedTopActivities: function () {
            this.topActivities.ensureFetched();
        },

        ensureFetchedRankedChannels: function (id) {
            var feed = this.rankedChannels[id];
            if (feed)
                feed.ensureFetched();
        },
    }, {
        RANKINGS: [
            {
                id: 'top',
                name: 'trending',
            },
            {
                id: 'popular',
                name: 'popular',
            },
            {
                id: 'recent',
                name: 'new',
            },
        ],

        // The id to use for the special ChannelGroupProfile that contains content
        // accross all Channel Groups.
        ALL_CHANNEL_GROUPS_PROFILE_ID: 'all channel groups',
    });

    UniqueModel.addType('ChannelGroupProfile', ChannelGroupProfile);

    return ChannelGroupProfile;
});

